import { Container } from "react-bootstrap";


export const GovernanceRiskCompliance = () => {
  return (
    <div>
      <header className="header">
        <h1>GOVERNANCE, RISK & COMPLIANCE</h1>
      </header>
      <Container>
        <div>
          <div>
            <p>
            Our core concept behind IT governance is making sure that organizations align business strategy with IT strategy. 
                    This means that the goal of IT governance is ultimately to ensure that the processes governing evaluation, selection, prioritization, and funding of competing IT investments are driven by the overall business. 
                
              Our IT governance are accompanied by processes to manage risk
              across the enterprise and also to ensure compliance with multiple
              regulations. We improve visibility to company wide risk, improve
              employee efficiency by automating controls and streamlining
              testing, implement necessary paperwork and controls to ensure
              compliance, and reduce the time to audit.
            </p>

            <ul>
              <li>
                We provide a single point of reference for managing risk
                associated with regulation and the challenges of meeting
                regulatory requirements.
              </li>
              <li>
                We offer a variety of risk and regulatory services to the market
                that includes:
              </li>

              <li>Corporate governance</li>
              <li>
                Identifying governance gaps and recommending governance
                improvements.
              </li>
              <li>Enterprise risk management</li>
              <li>Maintaining operational excellence for long term success.</li>

              <li>Financial risk management</li>
              <li>
                Identifying, measuring and managing market risk, credit risk and
                insurance risk.
              </li>

              <li>Regulatory advisory</li>
              <li>
                Helping you stay on top of your compliance issues – both at home
                and abroad.
              </li>
            </ul>
          </div>
        </div>
      </Container>
    </div>
  );
}

export const Strategy = () => {
  return (
    <div>
    <header className="header">
      <h1>STRATEGY</h1>
    </header>
    <Container>
    <div>
            {/* <!-- left --> */}
            <div>
                <h4>
                    We provide end-to-end services from strategy to business to technology consulting that are executable through our technology offerings.  
                </h4>
            </div>

            {/* <!-- right --> */}
            <div>
                    <p>
                        Nated Systems’ Strategy and Transformation Consulting brings a fresh
                        perspective to business transformation, anchored by Digital Change Lifecycle.
                        Our approach emphasizes inclusive, outside-in techniques as well as access to
                        expertise and innovation to explore the new digital business context, eliciting
                        new market strategies, capability requirements and a digital value-creation
                        agenda. Accelerate your digital transformation and bring guidance to your digital
                        enterprise journey. 
                    </p>
                    <p>
                        We’ll partner with you to accelerate your digital transformation with our world-class expertise.  
                    </p>

                    <h3>How can we help you</h3>
                    <ul>
                        <li>Strategic Alignment</li>
                        <li>
                        We execute strategies that will enable business to achieve sustainable
                        growth, enhanced performance and managed risk. We align stakeholders
                        around the transformational implications of their digital strategy, and
                        develop an executable transformation roadmap.
                        </li>
                        
                        <li>Strategy and innovation</li>
                        <li>
                        We translate strategy into executable transformation plans; create the
                        business cases; manage organizational change; and architect.
                        </li>
                        
                        <li>Strategic transformation</li>
                        <li>
                        we provide new opportunities to create value as you continuously
                        monetize initiatives on your transformation roadmap. Success is
                        measured by the economic value added to the business and the return on
                        invested capital.
                        </li>
                        
                        <li>Digital Strategy and Transformation</li>
                        <li>
                        We help companies thrive in the transformative age by refreshing
                        themselves constantly, experimenting with new ideas and scaling
                        successes.
                        </li>
                    </ul>

            </div>
        </div>
    </Container>
    </div>
  );
}

export const IntenetOfThings = () => {
  return (
    <div>
    <header className="header">
      <h1>INTERNET OF THINGS</h1>
    </header>
    <Container>
        {/* <!-- left --> */}
        <div>
            <h4>
                Nated Systems IoT Services has the expertise to help you build IoT capabilities that can increase operational efficiency and increase Revenue  
            </h4>
        </div>

        {/* <!-- right --> */}
        <div>
          <p>
             We hosts applications for customers and make the application available to them via the internet.
              Our business applications, including email and collaboration, customer relationship management (CRM), billing/payroll processing, enterprise resourcing planning (ERP), content management, and document editing and management.
              We hosts applications for customers and make the application available to them
              via the internet. Our business applications, including email and collaboration,
              customer relationship management (CRM), billing/payroll processing, enterprise
              resourcing planning (ERP), content management, and document editing and
              management. The SaaS model can reduce costs for IT infrastructure. It can also
              minimize some of the time spent on management tasks, because a SaaS
              provider is responsible for upgrades and management.
          </p>
          <p>
              The SaaS model can reduce costs for IT infrastructure. It can also minimize some of the time spent on management tasks, because a SaaS provider is responsible for upgrades and management.  
          </p>

          <h5>How can we help you</h5>
          <ul>
              <li>Stay up to date with the latest releases and unlimited upgrades </li>
              <li>Reduce capital expenditures and eliminate up-front costs </li>
              <li>Free up internal resources and let our administrators do the work </li>
              <li>Quickly scale and only pay for what you need, when you need it </li>
              <li>Secure, scalable, reliable and always available IT </li>
              <li>Require zero infrastructure to get up and running.  </li>
              <li>Integrates with other web-based applications.  </li>
              <li>Guaranteed 99.9% availability </li>
          </ul>
        </div>
    </Container>
    </div>
  );
}

export const BigData = () => {
  return (
    <div>
    <header className="header">
      <h1>BIG DATA & ANALYSIS</h1>
    </header>
    <Container>
    <div>

        <div>
            {/* <!-- left --> */}
            <div>
                <h4>
                    Nated Systems help companies bridge the ever widening span between
                    the overflow volume of complex data and optimize their ongoing
                    operations and realize a greater digital reach
                </h4>
            </div>

            {/* <!-- right --> */}
            <div>
                    <p>
                        Smart homes, the Internet of Things, social media, mobile applications, and
                        other technologies are generating an unprecedented amount of multistructured
                        data. This "big data" has the potential to transform businesses and industries
                        and to unlock tremendous value. It transforms how companies organize
                        themselves, decide which technologies to use. The time has come to value data
                        as a strategic asset that can help you win.                  
                    </p>

                    <p>
                        We can help you apply analytics throughout your organization to grow, protect
                        and optimize your business by harnessing the latest advanced technologies. The
                        true value lies in embedding analytics deeply into business processes at the
                        point where decisions are made – by human beings. We help you build the
                        structures and processes that convert data into a strategic asset, aligning data
                        capture and analytics within critical streams of the organization.
                    </p>

                    <h3>How can we help you</h3>
                    <ul>
                        <li>Create an agile and responsive finance operations:</li>
                        <li>New technologies and market entrants, changing customer needs and
                        behaviours, and exponentially growing data volumes create a need for
                        change. With our analytics we can help you to: Monitor performance
                        management; Reduce the costs of finance; Speed up financial systems;
                        Align people capabilities; Anticipate financial risks
                        </li>
                        
                        <li>Manage your risks to secure future success:</li>
                        <li>The need to secure sensitive data, to protect private information and to
                        manage data quality exists whether data sets are big or small. With our
                        analytics we can help you to: Improve risk and internal audit processes
                        and enable the business to deliver even better products and services;
                        Simplify regulatory processes and improve quality; Detect the next threat
                        </li>
                        
                        <li>Unlock the value of your customers:</li>
                        <li>Technology has empowered consumers to be smarter, better informed
                        and more demanding than ever. With our analytics can help you to:
                        Attract and retain the right customers; Unlock the full value of existing
                        customers; Optimize your channel mix
                        </li>
                        
                        <li>Create value in human resources:</li>
                        <li> can help to optimize resource planning as well as better
                        understand your employees, which in turn will support you in achieving
                        superior performance while reducing costs. Gain employee insight and
                        optimize resource allocation
                        </li>
                    </ul>

            </div>
        </div>
      </div>
    </Container>
    </div>
  );
}

export const ProgrammeManagement = () => {
  return (
    <div>
    <header className="header">
      <h1>BIG DATA & ANALYSIS</h1>
    </header>
    <Container>
    <div>

        <div>
            {/* <!-- left --> */}
            <div>
                <h4>
                    Nated Systems help companies bridge the ever widening span between
                    the overflow volume of complex data and optimize their ongoing
                    operations and realize a greater digital reach
                </h4>
            </div>

            {/* <!-- right --> */}
            <div>
                    <p>
                        Smart homes, the Internet of Things, social media, mobile applications, and
                        other technologies are generating an unprecedented amount of multistructured
                        data. This "big data" has the potential to transform businesses and industries
                        and to unlock tremendous value. It transforms how companies organize
                        themselves, decide which technologies to use. The time has come to value data
                        as a strategic asset that can help you win.                  
                    </p>

                    <p>
                        We can help you apply analytics throughout your organization to grow, protect
                        and optimize your business by harnessing the latest advanced technologies. The
                        true value lies in embedding analytics deeply into business processes at the
                        point where decisions are made – by human beings. We help you build the
                        structures and processes that convert data into a strategic asset, aligning data
                        capture and analytics within critical streams of the organization.
                    </p>

                    <h3>How can we help you</h3>
                    <ul>
                        <li>Create an agile and responsive finance operations:</li>
                        <li>New technologies and market entrants, changing customer needs and
                        behaviours, and exponentially growing data volumes create a need for
                        change. With our analytics we can help you to: Monitor performance
                        management; Reduce the costs of finance; Speed up financial systems;
                        Align people capabilities; Anticipate financial risks
                        </li>
                        
                        <li>Manage your risks to secure future success:</li>
                        <li>The need to secure sensitive data, to protect private information and to
                        manage data quality exists whether data sets are big or small. With our
                        analytics we can help you to: Improve risk and internal audit processes
                        and enable the business to deliver even better products and services;
                        Simplify regulatory processes and improve quality; Detect the next threat
                        </li>
                        
                        <li>Unlock the value of your customers:</li>
                        <li>Technology has empowered consumers to be smarter, better informed
                        and more demanding than ever. With our analytics can help you to:
                        Attract and retain the right customers; Unlock the full value of existing
                        customers; Optimize your channel mix
                        </li>
                        
                        <li>Create value in human resources:</li>
                        <li> can help to optimize resource planning as well as better
                        understand your employees, which in turn will support you in achieving
                        superior performance while reducing costs. Gain employee insight and
                        optimize resource allocation
                        </li>
                    </ul>

            </div>
        </div>
      </div>
    </Container>
    </div>
  );
}

export const ArtificialIntelligence = () => {
  return (
    <div>
    <header className="header">
      <h1>ARTIFICIAL INTELLIGENCE</h1>
    </header>
    <Container>
      <div>

          <div>
              {/* <!-- left --> */}
              <div>
                  <h4>
                      Artificial intelligence (AI) is transforming business. Our team work with you to
                      incorporate the robotic, intelligent and autonomous capabilities that will
                      transform and innovate the way you operate and compete in the digital world.
                  </h4>
              </div>

              {/* <!-- right --> */}
              <div>
                      <p>
                          To realize value from AI, it's a set of technologies and building blocks, all using
                          data to unlock intelligent value across industries and business functions. Our
                          consulting Services will help you leverage AI to drive transformation your
                          workflows and technology. We help businesses leverage the potential of their
                          massive data and convert them into decision-driven insights with our AI
                          consulting services. Our AI consulting experts and data scientists team ambition
                          are to build innovative solutions that can transform companies’ processes. Our
                          consulting team is ready to help you fully realize business benefits from AI.                  
                      </p>

                      <h3>How can we help you</h3>
                      <ul>
                          <li>We help you predict your customer behavior and outcomes and grow your business in the right direction. </li>
                          <li>We create algorithms that maximize accuracy and reduce errors by learning new things from collected data. </li>
                          <li>We use Natural Language Processing to develop custom AI applications that can extract meaning from structured and unstructured data to perform customer-centric initiatives. </li>
                          <li>We leverage robotic, intelligent and autonomous capabilities to transform operations through automation. </li>
                      </ul>

              </div>
          </div>
      </div>
    </Container>
    </div>
  );
}


